import React, { useRef } from "react";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";

const CustomDateField = styled(TextField)({
  '& .MuiInputBase-root:before, & .MuiInputBase-root.Mui-disabled:before': {
    border: 'none',
    borderBottomStyle: "none"
  },
  '& .MuiInput-underline:before': {
    borderBottom: 'none',
  },
  '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
    borderBottom: 'none',
  },
  '& .MuiInput-underline:after': {
    borderBottom: 'none',
  },
  '& .MuiInputLabel-root': {
    '&.Mui-focused': {
      color: '#26a69a',
    },
  },
  'input[type=date]:not(.browser-default):focus:not([readonly])': {
    borderBottom: "1px solid #26a69a",
    boxShadow: '0 1px 0 0 #26a69a'
  },
  'input[type=date]:not(.browser-default):hover:not([readonly]):not(:focus)': {
    borderColor: "black"
  },
  '& .MuiInputBase-input.Mui-disabled': {
    color: 'rgba(0, 0, 0, 0.87)',
    WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
  },
  '& input::-webkit-calendar-picker-indicator': {
    display: 'none',
  },
});

function MuiDate({ value, onChange, label, disabled, error }) {
  const inputRef = useRef(null);

  return (
    <CustomDateField
      inputRef={inputRef}
      type="date"
      value={value}
      onChange={e => onChange(e.target.value)}
      label={label}
      disabled={disabled}
      error={error}
      fullWidth
      variant="standard"
      onClick={() => inputRef.current?.showPicker()}
      InputLabelProps={{ shrink: !!value }}
      inputProps={{
        style: { color: value ? "inherit" : "transparent" }
      }}
    />
  );
}

export default MuiDate;